import Http from "@/utils/request.js"

// 用户信息
export const UserInfo = (data) => {
	return Http.request({
		url: '/stock/user/info',
		method: 'post',
		data
	})
}

// 开户
export const OpenAccount = data => {
	return Http.request({
		url: '/stock/accountApply/openAccountApply',
		method: 'post',
		data
	})
}

// 修改密码
export const ChangePassword = data => {
	return Http.request({
		url: '/stock/user/changePassword',
		method: 'post',
		data
	})
}

// 设置/修改资金密码（首次设置不传 oldPayPassword，修改时必传）
export const SetPayPassword = data => {
	return Http.request({
		url: '/stock/user/setPayPassword',
		method: 'post',
		data
	})
}

//  修改用户信息
export const ChangeUserInfo = data => { 
	return Http.request({
		url: '/stock/user/changeUserInfo',
		method: 'post',
		data
	})
}

// 设置新股自动申购开关
// data: { autoSubscribeIpo: 0 | 1 }
export const UpdateAutoSubscribeIpo = data => {
	return Http.request({
		url: '/stock/user/updateAutoSubscribeIpo',
		method: 'post',
		data
	})
}

// 获取 kyc 状态
export const GetKycStatus = data => {
	return Http.request({
		url: '/stock/accountApply/applyDetail',
		method: 'post',
		data
	})
}